// FETCH ALL STITCHING INWARD
export const FETCH_STITCHING_INWARD_MASTER_REQUEST_DK = 'FETCH_STITCHING_INWARD_MASTER_REQUEST_DK';
export const FETCH_STITCHING_INWARD_MASTER_SUCCESS_DK = 'FETCH_STITCHING_INWARD_MASTER_SUCCESS_DK';
export const FETCH_STITCHING_INWARD_MASTER_FAILURE_DK = 'FETCH_STITCHING_INWARD_MASTER_FAILURE_DK';

// FETCH ALL STITCHING INWARD
export const FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK = 'FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK';
export const FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK = 'FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK';
export const FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK = 'FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK';

// CREATE STITCHING INWARD
export const CREATE_STITCHING_INWARD_MASTER_REQUEST_DK = 'CREATE_STITCHING_INWARD_MASTER_REQUEST_DK';
export const CREATE_STITCHING_INWARD_MASTER_SUCCESS_DK = 'CREATE_STITCHING_INWARD_MASTER_SUCCESS_DK';
export const CREATE_STITCHING_INWARD_MASTER_FAILURE_DK = 'CREATE_STITCHING_INWARD_MASTER_FAILURE_DK';

// CREATE STITCHING INWARD
export const CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_REQUEST_DK = 'CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_REQUEST_DK';
export const CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK = 'CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK';
export const CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_FAILURE_DK = 'CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_FAILURE_DK';

// UPDATE STITCHING INWARD
export const UPDATE_STITCHING_INWARD_MASTER_REQUEST_DK = 'UPDATE_STITCHING_INWARD_MASTER_REQUEST_DK';
export const UPDATE_STITCHING_INWARD_MASTER_SUCCESS_DK = 'UPDATE_STITCHING_INWARD_MASTER_SUCCESS_DK';
export const UPDATE_STITCHING_INWARD_MASTER_FAILURE_DK = 'UPDATE_STITCHING_INWARD_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF STITCHING INWARD
export const FETCH_SINGLE_STITCHING_INWARD_MASTER_REQUEST_DK = 'FETCH_SINGLE_STITCHING_INWARD_MASTER_REQUEST_DK';
export const FETCH_SINGLE_STITCHING_INWARD_MASTER_SUCCESS_DK = 'FETCH_SINGLE_STITCHING_INWARD_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_STITCHING_INWARD_MASTER_FAILURE_DK = 'FETCH_SINGLE_STITCHING_INWARD_MASTER_FAILURE_DK';

// DELETE STITCHING INWARD
export const DELETE_STITCHING_INWARD_MASTER_REQUEST_DK = 'DELETE_STITCHING_INWARD_MASTER_REQUEST_DK';
export const DELETE_STITCHING_INWARD_MASTER_SUCCESS_DK = 'DELETE_STITCHING_INWARD_MASTER_SUCCESS_DK';
export const DELETE_STITCHING_INWARD_MASTER_FAILURE_DK = 'DELETE_STITCHING_INWARD_MASTER_FAILURE_DK';

export const FETCH_PENDING_STITCHING_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_STITCHING_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_STITCHING_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_STITCHING_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_STITCHING_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_STITCHING_PO_IN_INWARD_FAILURE_DK';

export const RESET_STITCHING_INWARD_MASTER_INFO_DK = 'RESET_STITCHING_INWARD_MASTER_INFO_DK';

export const CREATE_STITCHING_INWARD_MASTER_FORM_DK = 'CREATE_STITCHING_INWARD_MASTER_FORM_DK';

export const UPDATE_STITCHING_INWARD_MASTER_FORM_DK = 'UPDATE_STITCHING_INWARD_MASTER_FORM_DK';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_STITCHING_INWARD_DETAILS_DK = 'NAVIGATE_STITCHING_INWARD_DETAILS_DK';

// NAVIGATE TO STITCHING INWARD COMPONENT
export const NAVIGATE_STITCHING_INWARD_MASTER_DK = 'NAVIGATE_STITCHING_INWARD_MASTER_DK';

export const RESET_FORM_DATA_WITHOUT_STITCHING_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_STITCHING_INWARD_ID_DK';

export const RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID_DK = 'RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID_DK';

export const SET_ACTIVE_KEY_STITCHING_INWARD_DK = 'SET_ACTIVE_KEY_STITCHING_INWARD_DK';


export const SET_PENDING_GRID_NAME_STITCHING_INWARD_DK = 'SET_PENDING_GRID_NAME_STITCHING_INWARD_DK';
export const SET_UNIT_NAME_STITCHING_INWARD_DK = 'SET_UNIT_NAME_STITCHING_INWARD_DK';

export const FETCH_COMPLETE_STITCHING_DC_IN_INWARD_REQUEST_DK = 'FETCH_COMPLETE_STITCHING_DC_IN_INWARD_REQUEST_DK';
export const FETCH_COMPLETE_STITCHING_DC_IN_INWARD_SUCCESS_DK = 'FETCH_COMPLETE_STITCHING_DC_IN_INWARD_SUCCESS_DK';
export const FETCH_COMPLETE_STITCHING_DC_IN_INWARD_FAILURE_DK = 'FETCH_COMPLETE_STITCHING_DC_IN_INWARD_FAILURE_DK';


export const FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK';